module.exports = __webpack_public_path__ + "img/banner04-mobile.890510d4.png";